export const GET_COMMENTS_REQUEST = "GET_COMMENTS_REQUEST";
export const GET_COMMENTS_SUCCESS = "GET_COMMENTS_SUCCESS";
export const GET_COMMENTS_FAILURE = "GET_COMMENTS_FAILURE";

export const ADD_COMMENT_REQUEST = "ADD_COMMENT_REQUEST";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAILURE = "ADD_COMMENT_FAILURE";

export const UPDATE_COMMENT_REQUEST = "UPDATE_COMMENT_REQUEST";
export const UPDATE_COMMENT_SUCCESS = "UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_FAILURE = "UPDATE_COMMENT_FAILURE";

export const DELETE_COMMENT_REQUEST = "DELETE_COMMENT_REQUEST";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAILURE = "DELETE_COMMENT_FAILURE";

export const GET_COMMENTS_PERMISSION_REQUEST = "GET_COMMENTS_PERMISSION_REQUEST";
export const GET_COMMENTS_PERMISSION_SUCCESS = "GET_COMMENTS_PERMISSION_SUCCESS";
export const GET_COMMENTS_PERMISSION_FAILURE = "GET_COMMENTS_PERMISSION_FAILURE";

export const getCommentsRequest = (recordId) => ({
    type: GET_COMMENTS_REQUEST,
    payload: recordId,
});

export const getCommentsSuccess = (recordId, comments) => ({
    type: GET_COMMENTS_SUCCESS,
    payload: { recordId, comments },
});

export const getCommentsFailure = (error) => ({
    type: GET_COMMENTS_FAILURE,
    payload: error,
});

export const addCommentRequest = (recordId, commentData) => ({
    type: ADD_COMMENT_REQUEST,
    payload: { recordId, commentData },
});

export const addCommentSuccess = (recordId, comment) => ({
    type: ADD_COMMENT_SUCCESS,
    payload: { recordId, comment },
});

export const addCommentFailure = (error) => ({
    type: ADD_COMMENT_FAILURE,
    payload: error,
});

export const updateCommentRequest = (recordId, commentId, commentData) => ({
    type: UPDATE_COMMENT_REQUEST,
    payload: { recordId, commentId, commentData },
});

export const updateCommentSuccess = (recordId, comment) => ({
    type: UPDATE_COMMENT_SUCCESS,
    payload: { recordId, comment },
});

export const updateCommentFailure = (error) => ({
    type: UPDATE_COMMENT_FAILURE,
    payload: error,
});

export const deleteCommentRequest = (recordId, commentId) => ({
    type: DELETE_COMMENT_REQUEST,
    payload: { recordId, commentId },
});

export const deleteCommentSuccess = (recordId, commentId) => ({
    type: DELETE_COMMENT_SUCCESS,
    payload: { recordId, commentId },
});

export const deleteCommentFailure = (error) => ({
    type: DELETE_COMMENT_FAILURE,
    payload: error,
});

export const getCommentsPermissionRequest = () => ({
    type: GET_COMMENTS_PERMISSION_REQUEST,
});

export const getCommentsPermissionSuccess = (permissions) => ({
    type: GET_COMMENTS_PERMISSION_SUCCESS,
    payload: permissions,
});

export const getCommentsPermissionFailure = (error) => ({
    type: GET_COMMENTS_PERMISSION_FAILURE,
    payload: error,
});
